import React from "react";
import Hero from "../components/Hero";
import Pillars from "../components/Pillars";
import About from "../components/About";
import Infrastructure from "../components/Infrastructure";
import Ecosystem from "../components/Ecosystem";
import KprGroup from "../components/KprGroup";
import CampusLife from "../components/CampusLife";
import Curriculum from "../components/Curriculum";
import Institutions from "../components/Institutions";
import Faq from "../components/Faq";
import Contact from "../components/Contact";
import CtaBand from "../components/CtaBand";
import { site } from "../mock/mock";
import useSeo from "../hooks/useSeo";

export default function Home() {
  useSeo({
    path: "/",
    description:
      "The KPR Academy is a CBSE school in Arasur, Coimbatore offering Pre-KG to Grade VII on a 160+ acre campus. Smart classrooms, science and AI labs, robotics studio, library, auditorium, athletics track and swimming complex. Admissions open 2026-27.",
    keywords:
      "CBSE school Coimbatore, best school in Coimbatore, KPR Academy, school admissions Coimbatore, Pre-KG admission Coimbatore, Arasur school, KPR Institutions",
  });

  const apply = () => window.open(site.applyUrl, "_blank", "noopener");

  return (
    <>
      <Hero onApply={apply} />
      <Pillars />
      <About />
      <Ecosystem />
      <KprGroup />
      <Infrastructure />
      <CampusLife />
      <Curriculum />
      <Institutions />
      <CtaBand />
      <Faq />
      <Contact />
    </>
  );
}
